import gql from 'graphql-tag';
import { IncidentFragment } from '@app/pages/cmms/graphql/incident.queries';

export const CreateIncidentMutation = gql`
	mutation CreateIncident(
		$name: String!
		$priority: Int
		$status: IncidentStatus
		$description: String
		$category: IncidentCategories
		$approvedBy: UUID
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$files: [UUID]
		$workOrders: [UUID]
		$requests: [UUID]
		$locations: [LocationInput]
		$assets: [AssetInput]
		$coordinates: DigitalTwinCoordinatesInput
		$occurredAt: DateTime
		$timeframe: TimeframeChoices
		$costAllocation: CostAllocationChoices
		$costOfRepair: Decimal
		$consequenceRating: ConsequenceRatingChoices
		$riskLevel: RiskLevelChoices
		$deviationType: DeviationTypeChoices
		$deadline: DateTime
		$labels: [UUID]
	) {
		createIncident(
			name: $name
			priority: $priority
			status: $status
			description: $description
			category: $category
			assignee: $assignee
			assigneeType: $assigneeType
			approvedBy: $approvedBy
			files: $files
			workOrders: $workOrders
			requests: $requests
			locations: $locations
			assets: $assets
			coordinates: $coordinates
			occurredAt: $occurredAt
			timeframe: $timeframe
			costAllocation: $costAllocation
			costOfRepair: $costOfRepair
			consequenceRating: $consequenceRating
			riskLevel: $riskLevel
			deviationType: $deviationType
			deadline: $deadline
			labels: $labels
		) {
			success
			incident {
				...IncidentFragment
				coordinates {
					x
					y
					z
				}
			}
		}
	}
	${IncidentFragment}
`;

export const EditIncidentMutation = gql`
	mutation EditIncidentMutation(
		$pk: UUID!
		$priority: Int
		$status: IncidentStatus
		$description: String
		$category: IncidentCategories
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$approvedBy: UUID
		$name: String
		$files: [UUID]
		$requests: [UUID]
		$workOrders: [UUID]
		$locations: [LocationInput]
		$assets: [AssetInput]
		$occurredAt: DateTime
		$coordinates: DigitalTwinCoordinatesInput
		$timeframe: TimeframeChoices
		$costAllocation: CostAllocationChoices
		$costOfRepair: Decimal
		$consequenceRating: ConsequenceRatingChoices
		$riskLevel: RiskLevelChoices
		$deviationType: DeviationTypeChoices
		$deadline: DateTime
		$labels: [UUID]
	) {
		editIncident(
			pk: $pk
			priority: $priority
			status: $status
			description: $description
			category: $category
			assignee: $assignee
			assigneeType: $assigneeType
			approvedBy: $approvedBy
			name: $name
			files: $files
			requests: $requests
			workOrders: $workOrders
			locations: $locations
			assets: $assets
			occurredAt: $occurredAt
			coordinates: $coordinates
			timeframe: $timeframe
			costAllocation: $costAllocation
			costOfRepair: $costOfRepair
			consequenceRating: $consequenceRating
			riskLevel: $riskLevel
			deviationType: $deviationType
			deadline: $deadline
			labels: $labels
		) {
			success
			incident {
				...IncidentFragment
				coordinates {
					x
					y
					z
				}
			}
		}
	}
	${IncidentFragment}
`;

export const DeleteIncident = gql`
	mutation DeleteIncident($pk: UUID!) {
		deleteIncident(pk: $pk) {
			success
		}
	}
`;

export const DeleteIncidents = gql`
	mutation DeleteIncidents($incidents: [UUID]!) {
		deleteIncidents(incidents: $incidents) {
			success
		}
	}
`;

export const UnlinkIncidentObjects = gql`
	mutation UnlinkIncidentObjects($pk: UUID!, $requests: [UUID], $workOrders: [UUID]) {
		unlinkIncidentObjects(pk: $pk, requests: $requests, workOrders: $workOrders) {
			success
		}
	}
`;

export const LinkIncidentsMutation = gql`
	mutation (
		$incidents: [UUID!]!
		$status: IncidentStatus
		$priority: Int
		$category: IncidentCategories
		$workOrders: [UUID!]
		$requests: [UUID!]
		$labels: [UUID!]
	) {
		linkIncidents(
			incidents: $incidents
			status: $status
			priority: $priority
			category: $category
			workOrders: $workOrders
			requests: $requests
			labels: $labels
		) {
			success
		}
	}
`;
